import React from "react";
import classes from "./index.module.scss";
import { Button, Icon } from "antd";
import { exportSignInStu } from "service/signIn";
import { SignType } from "service/signIn";

interface SignInExportProps {
    signInId: number;
    percentage: string;
    type: SignType;
}

export default function SignInExport({
    signInId,
    percentage,
    type
}: SignInExportProps) {
    return (
        <div className={classes.root}>
            <div className={classes.text}>出勤率 {percentage}</div>
            <Button
                type="primary"
                ghost
                className={classes.button}
                onClick={() => exportSignInStu(signInId, type)}>
                <Icon type="cloud-download" /> 导出数据
            </Button>
        </div>
    );
}
